import { useQuery } from 'react-query';

import firehydrantAPI from '../../helpers/firehydrantAPI';

export function usePushNotificationDevices(params) {
  const requestParams = { params: { per_page: 20, ...params } };

  const { data: requestData = { data: { data: [] } }, ...query } = useQuery(
    ['push_notification_devices', requestParams],
    () => firehydrantAPI.get('/push_notification_devices', requestParams),
  );

  return {
    ...query,
    data: requestData?.data?.data,
    pagination: requestData?.data?.pagination || {},
  };
}
